// Generated from the Rust smart block contracts. Do not edit.

export const AgentChecklistBlockConfigSchema = {
  additionalProperties: false,
  properties: {
    items: {
      items: {
        pattern: '[^\\u0009-\\u000d\\u0020\\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000]',
        type: 'string',
      },
      type: 'array',
    },
    title: {
      nullable: true,
      pattern: '[^\\u0009-\\u000d\\u0020\\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000]',
      type: 'string',
    },
  },
  required: ['items'],
  title: 'AgentChecklistBlockConfig',
  type: 'object',
} as const;

export const AgentProcedureBlockConfigSchema = {
  additionalProperties: false,
  properties: {
    steps: {
      items: {
        pattern: '[^\\u0009-\\u000d\\u0020\\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000]',
        type: 'string',
      },
      type: 'array',
    },
    title: {
      nullable: true,
      pattern: '[^\\u0009-\\u000d\\u0020\\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000]',
      type: 'string',
    },
  },
  required: ['steps'],
  title: 'AgentProcedureBlockConfig',
  type: 'object',
} as const;

export const InstructionBlockKindSchema = {
  enum: ['checklist', 'procedure'],
  title: 'InstructionBlockKind',
  type: 'string',
} as const;

export const InstructionChecklistBlockConfigSchema = {
  additionalProperties: false,
  properties: {
    items: {
      items: {
        not: {
          pattern: '[\\n\\r\\u000b\\u000c\\u0085\\u2028\\u2029]',
          type: 'string',
        },
        pattern: '[^\\u0009-\\u000d\\u0020\\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000]',
        type: 'string',
      },
      type: 'array',
    },
    title: {
      not: {
        pattern: '[\\n\\r\\u000b\\u000c\\u0085\\u2028\\u2029]',
        type: 'string',
      },
      nullable: true,
      pattern: '[^\\u0009-\\u000d\\u0020\\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000]',
      type: 'string',
    },
  },
  required: ['items'],
  title: 'InstructionChecklistBlockConfig',
  type: 'object',
} as const;

export const InstructionProcedureBlockConfigSchema = {
  additionalProperties: false,
  properties: {
    steps: {
      items: {
        not: {
          pattern: '[\\n\\r\\u000b\\u000c\\u0085\\u2028\\u2029]',
          type: 'string',
        },
        pattern: '[^\\u0009-\\u000d\\u0020\\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000]',
        type: 'string',
      },
      type: 'array',
    },
    title: {
      not: {
        pattern: '[\\n\\r\\u000b\\u000c\\u0085\\u2028\\u2029]',
        type: 'string',
      },
      nullable: true,
      pattern: '[^\\u0009-\\u000d\\u0020\\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000]',
      type: 'string',
    },
  },
  required: ['steps'],
  title: 'InstructionProcedureBlockConfig',
  type: 'object',
} as const;
